import moment from 'moment';

export function dateFormat(format, date) {
  return (date) ?
    moment(date).format(format || 'YYYY-MM-DD') :
    moment().format(format || 'YYYY-MM-DD');
}

export function maxDate(format) {
  return moment('3000-01-01').format(format || 'YYYY-MM-DD');
}

export function minDate(format) {
  return moment('1900-01-01').format(format || 'YYYY-MM-DD');
}

export function maxDateUtc() {
  return moment('3000-01-01').endOf('day').toISOString();
}

export function minDateUtc() {
  return moment('1900-01-01').startOf('day').toISOString();
}

export function convertUtcDate(date) {
  return (date) ? moment(date).toISOString() : moment().toISOString();
}

export function convertLocalDate(date, format) {
  return (date) ?
    moment(date).local().format(format || 'YYYY-MM-DD') :
    moment().local().format(format || 'YYYY-MM-DD');
}

export function getDateRangeBetweenDates(monthsAway) {
  let startOfMonth;
  const days = {};
  days.lastMonth = false;
  if (monthsAway === -1 || monthsAway === '-1') {
    days.days = '-1';
  } else {
    const today = moment();
    if (parseInt(monthsAway) > 1) {
      startOfMonth = moment().subtract(monthsAway - 1, 'months').startOf('month');
      days.days = today.diff(startOfMonth, 'days');
    } else if (monthsAway === 1 || monthsAway === '1') {
      startOfMonth = moment().subtract(1, 'month').startOf('month');
      const endOfMonth = moment().subtract(1, 'month').endOf('month');
      days.days = endOfMonth.diff(startOfMonth, 'days');
      days.lastMonth = true;
    } else if (monthsAway === 0 || monthsAway === '0') {
      startOfMonth = moment().startOf('month');
      days.days = today.diff(startOfMonth, 'days');
    }
  }
  return days;
}

export function grabMonthsToAndFromDates(days, fromDate, toDate, lastMonth) {
  let dateRange = -1;
  if (days != null) { dateRange = days; }
  const date = {
    fromDate: '',
    toDate: '',
  };
  let dateGT = '';
  let dateLT = '';
  dateGT = (fromDate) ? moment(fromDate).startOf('day').toISOString() : minDateUtc();
  dateLT = (toDate) ? moment(toDate).endOf('day').toISOString() : maxDateUtc();
  if (!(dateRange === '-1' || dateRange === -1)) {
    dateLT = moment().endOf('day').toISOString();
    dateGT = moment(dateLT).startOf('day').subtract(days, 'days').toISOString();
  }
  if (lastMonth) {
    dateGT = moment().subtract(1, 'month').startOf('month');
    dateLT = moment(dateGT).endOf('month').subtract(1, 'day');
    dateGT = dateGT.toISOString();
    dateLT = dateLT.toISOString();
  }
  date.fromDate = dateGT;
  date.toDate = dateLT;
  return date;
}

export function toFromDates(days, fromDate, toDate, format) {
  let dateRange = -1;
  if (days != null) { dateRange = days; }
  const date = {
    fromDate: '',
    toDate: '',
  };
  let dateGT = '';
  let dateLT = '';
  if (format) {
    if (!(dateRange === '-1' || dateRange === -1)) {
      dateLT = moment().local().endOf('day').format(format);
      if (dateRange === '1' || dateRange === 1) {
        dateGT = moment().local().startOf('day').format(format);
      } else if (dateRange === '2' || dateRange === 2) {
        dateGT = moment(dateLT).local().subtract('2', 'days').startOf('day').format(format);
      } else if (dateRange === '7' || dateRange === 7) {
        dateGT = moment(dateLT).local().subtract('7', 'days').startOf('day').format(format);
      } else if (dateRange === '30' || dateRange === 30) {
        dateGT = moment(dateLT).local().subtract('30', 'days').startOf('day').format(format);
      } else if (dateRange === '90' || dateRange === 90) {
        dateGT = moment(dateLT).local().subtract('90', 'days').startOf('day').format(format);
      }
    }
  } else {
    dateGT = (fromDate) ? moment(fromDate).startOf('day').toISOString() : minDateUtc();
    dateLT = (toDate) ? moment(toDate).endOf('day').toISOString() : maxDateUtc();
    if (!(dateRange === '-1' || dateRange === -1)) {
      dateLT = moment().endOf('day').toISOString();
      if (dateRange === '1' || dateRange === 1) {
        dateGT = moment().startOf('day').toISOString();
      } else if (dateRange === '2' || dateRange === 2) {
        dateGT = moment(dateLT).startOf('day').subtract('2', 'days').toISOString();
      } else if (dateRange === '7' || dateRange === 7) {
        dateGT = moment(dateLT).startOf('day').subtract('7', 'days').toISOString();
      } else if (dateRange === '30' || dateRange === 30) {
        dateGT = moment(dateLT).startOf('day').subtract('30', 'days').toISOString();
      } else if (dateRange === '60' || dateRange === 60) {
        dateGT = moment(dateLT).startOf('day').subtract('60', 'days').toISOString();
      } else if (dateRange === '90' || dateRange === 90) {
        dateGT = moment(dateLT).startOf('day').subtract('90', 'days').toISOString();
      } else {
        dateGT = moment(dateLT).startOf('day').subtract(days, 'days').toISOString();
      }
    }
  }
  date.fromDate = dateGT;
  date.toDate = dateLT;
  return date;
}


export function toFromDispatchDates(days, dispatchDateLT, dispatchDateGT, format) {
  let dateRange = -1;
  if (days != null) { dateRange = days; }
  const date = {
    dispatchDateLT: '',
    dispatchDateGT: '',
  };
  let dateLT = '';
  let dateGT = '';
  if (format) {
    dateGT = (dispatchDateGT) ? moment(dispatchDateGT).startOf('day').toISOString() : minDateUtc();
    dateLT = (dispatchDateLT) ? moment(dispatchDateLT).endOf('day').toISOString() : maxDateUtc();
    if (!(dateRange === '-1' || dateRange === -1)) {
      dateLT = moment().local().endOf('day').format(format);
      if (dateRange === '1' || dateRange === 1) {
        dateGT = moment().local().startOf('day').format(format);
      } else if (dateRange === '7' || dateRange === 7) {
        dateGT = moment(dateLT).local().subtract('7', 'days').startOf('day').format(format);
      } else if (dateRange === '30' || dateRange === 30) {
        dateGT = moment(dateLT).local().subtract('30', 'days').startOf('day').format(format);
      } else if (dateRange === '90' || dateRange === 90) {
        dateGT = moment(dateLT).local().subtract('90', 'days').startOf('day').format(format);
      }
    }
  } else {
    dateGT = (dispatchDateLT) ? moment(dispatchDateLT).startOf('day').toISOString() : minDateUtc();
    dateLT = (dispatchDateGT) ? moment(dispatchDateGT).endOf('day').toISOString() : maxDateUtc();
    if (!(dateRange === '-1' || dateRange === -1)) {
      dateLT = moment().endOf('day').toISOString();
      if (dateRange === '1' || dateRange === 1) {
        dateGT = moment().startOf('day').toISOString();
      } else if (dateRange === '7' || dateRange === 7) {
        dateGT = moment(dateLT).startOf('day').subtract('7', 'days').toISOString();
      } else if (dateRange === '30' || dateRange === 30) {
        dateGT = moment(dateLT).startOf('day').subtract('30', 'days').toISOString();
      } else if (dateRange === '90' || dateRange === 90) {
        dateGT = moment(dateLT).startOf('day').subtract('90', 'days').toISOString();
      }
    }
  }
  date.dispatchDateGT = dateGT;
  date.dispatchDateLT = dateLT;
  return date;
}

/*
* @unit definition, default value = 'day'
* 'year'    // set to January 1st, 12:00 am this year
* 'month'   // set to the first of this month, 12:00 am
* 'quarter'  // set to the beginning of the current quarter, 1st day of months, 12:00 am
* 'week'    // set to the first day of this week, 12:00 am
* 'isoWeek' // set to the first day of this week according to ISO 8601, 12:00 am
* 'day'     // set to 12:00 am today
* 'date'     // set to 12:00 am today
* 'hour'    // set to now, but with 0 mins, 0 secs, and 0 ms
* 'minute'  // set to now, but with 0 seconds and 0 milliseconds
* 'second'  // same as moment().milliseconds(0);
*/
export function getFromToDates(date, unit = 'day') {
  if (date) {
    return {
      fromDate: convertUtcDate(moment(date).startOf(unit)),
      toDate: convertUtcDate(moment(date).endOf(unit)),
    };
  }
  return {};
}

export function getFromToDatesWithFilter({ FromDate, ToDate, Year, Quarter, Month }) {
  let fromDate = FromDate ? (moment(FromDate).startOf('day')).toISOString() : minDateUtc();
  let toDate = ToDate ? (moment(ToDate).endOf('day')).toISOString() : maxDateUtc();
  if (Year) {
    if (Month) {
      // Moment month is 0 based
      fromDate = moment([Year.value, Month.value - 1]);
      toDate = moment(fromDate).endOf('month');
    } else if (Quarter) {
      // Starting month: 1 -> 0, 2 -> 3, 3 -> 6, 4 -> 9
      fromDate = moment([Year.value, (Quarter.value - 1) * 3]);
      // Ending month: 1 -> 2, 2 -> 5, 3 -> 8, 4 -> 11
      toDate = moment([Year.value, (Quarter.value * 3) - 1]).endOf('month');
    } else {
      // Moment month is 0 based
      fromDate = moment().startOf('year');
      toDate = moment().endOf('year');
    }
    fromDate = fromDate.toISOString();
    toDate = toDate.toISOString();
  }
  return { fromDate, toDate };
}

/**
 *
 * @param {Number} hours
 * @param {Date} date
 * @returns An ISOString of the specified date and hours in UTC
 */
export function convertTimeToUtc(hours, date) {
  return (
    moment(date)
      .startOf('day')
      .add(hours, 'hours')
      .toISOString()
  );
}



// WEBPACK FOOTER //
// ./master/jsx/components/Common/cleanDates.jsx